// API configuration
// Use relative URLs in production, localhost in development
export const API_BASE_URL = import.meta.env.DEV 
  ? 'http://localhost:5000' 
  : ''; // Empty string means use same domain (nginx will proxy)

// Helper function to get full API URL
export const getApiUrl = (endpoint: string) => {
  // Remove leading slash if present for absolute URL construction
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  
  // If API_BASE_URL is empty (production), return the endpoint as-is (relative URL)
  // If API_BASE_URL is set (development), construct full URL
  return API_BASE_URL ? `${API_BASE_URL}${cleanEndpoint}` : cleanEndpoint;
};

// Helper function for API calls
export const apiCall = async (endpoint: string, options?: RequestInit) => {
  const url = getApiUrl(endpoint);
  const response = await fetch(url, {
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    ...options,
  });
  
  if (!response.ok) {
    throw new Error(`API call failed: ${response.status} ${response.statusText}`);
  }
  
  return response;
};

export const createNotification = async (userId: string, title: string, message: string, meta?: any) => {
  const url = getApiUrl('/api/notifications');
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ userId, title, message, meta })
  });
  if (!response.ok) throw new Error('Failed to create notification');
  return response.json();
};
